export default "__VITE_ASSET__CIza7_kj__"